import React, { useState } from 'react';
import {
  Avatar,
  Box,
  CircularProgress,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import PieChartIcon from '@mui/icons-material/PieChart';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import HolidayVillageRoundedIcon from '@mui/icons-material/HolidayVillageRounded';
import BrowserUpdatedOutlinedIcon from '@mui/icons-material/BrowserUpdatedOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import LogoutIcon from '@mui/icons-material/Logout';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { userSelector } from '../../../store/user/user.selector';
import { privateRoutes } from '../../../configs/routes';
import { logout } from '../../../apis/logout';
import packageJSON from '../../../../package.json';
import CustomButton from '../../UI/CustomButton';
import { setOpenDepositDialog, setSnackbar } from '../../../store/common/common.reducer';
import commafy from '../../../utils/commafyHelper';
import { getOrgInfo, removeOrgLog, uploadOrgLogo } from '../../../apis/user';
import './sidebar.scss';
import ConfirmDialog from '../../UserManagement/ConfirmDialog';
import { setUser } from '../../../store/user/user.reducer';

const useStyles = makeStyles(() => ({
  root: {
    margin: '0.2rem 0 0.2rem 0.4rem !important',
    padding: '0.5rem 0.5rem !important',
  },
  selected: {
    color: '#FF6B00 !important',
    backgroundColor: '#FFF1E6 !important',
    borderRadius: '0.3rem !important',
  },
}));

const Sidebar = ({ closeMenu, openMenu }) => {
  const isMobile = useMediaQuery('(max-width:1438px)');
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const user = useSelector(userSelector);
  const { firstName, lastName, organisationName, amount, orgLogo } = user || {};
  const [removeLoading, setRemoveLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [file, setFile] = useState(null);

  const adminSidebarItem = [
    {
      id: 'a1',
      label: 'داشبورد',
      href: privateRoutes.dashboard,
      icon: <PieChartIcon color={pathname === privateRoutes.dashboard ? 'primary' : 'action'} />,
      onClick: () => {
        if (openMenu) closeMenu?.();
        navigate(privateRoutes.dashboard);
      },
    },
    {
      id: 'a2',
      label: 'مدیریت کاربران سازمان',
      href: privateRoutes.userManagement,
      icon: <PeopleIcon color={pathname === privateRoutes.userManagement ? 'primary' : 'action'} />,
      onClick: () => {
        if (openMenu) closeMenu?.();
        navigate(privateRoutes.userManagement);
      },
    },
    {
      id: 'a3',
      label: 'گزارشات',
      href: privateRoutes.reports,
      icon: <DescriptionIcon color={pathname === privateRoutes.reports ? 'primary' : 'action'} />,
      onClick: () => {
        if (openMenu) closeMenu?.();
        navigate(privateRoutes.reports);
      },
    },
    // {
    //   id: 'a4',
    //   label: 'اخبار و اطلاعیه سازمان',
    //   href: privateRoutes.news,
    //   icon: <LiveTvRoundedIcon color={pathname === privateRoutes.news ? 'primary' : 'action'} />,
    //   onClick: () => {
    //     if (openMenu) closeMenu?.();
    //     navigate(privateRoutes.news);
    //   },
    // },
    {
      id: 'a5',
      label: 'تراکنش ها',
      href: privateRoutes.transaction,
      icon: (
        <ReceiptLongRoundedIcon
          color={pathname === privateRoutes.transaction ? 'primary' : 'action'}
        />
      ),
      onClick: () => {
        if (openMenu) closeMenu?.();
        navigate(privateRoutes.transaction);
      },
    },
    {
      id: 'a7',
      label: 'محصولات',
      href: privateRoutes.product,
      icon: (
        <BallotOutlinedIcon color={pathname === privateRoutes.product ? 'primary' : 'action'} />
      ),
      onClick: () => {
        if (openMenu) closeMenu?.();
        navigate(privateRoutes.product);
      },
    },
    {
      id: 'a6',
      label: 'خرید های سازمان',
      href: privateRoutes.purchases,
      icon: (
        <HolidayVillageRoundedIcon
          color={pathname === privateRoutes.purchases ? 'primary' : 'action'}
        />
      ),
      onClick: () => {
        if (openMenu) closeMenu?.();
        navigate(privateRoutes.purchases);
      },
    },
    {
      id: 'a7',
      label: 'فرصت های شغلی',
      href: privateRoutes.jobOffer,
      icon: (
        <FactCheckOutlinedIcon color={pathname === privateRoutes.jobOffer ? 'primary' : 'action'} />
      ),
      onClick: () => {
        if (openMenu) closeMenu?.();
        navigate(privateRoutes.jobOffer);
      },
    },
    {
      id: 'a8',
      label: 'رزومه‌های دریافتی',
      href: privateRoutes.jobApplication,
      icon: (
        <BrowserUpdatedOutlinedIcon
          color={pathname === privateRoutes.jobApplication ? 'primary' : 'action'}
        />
      ),
      onClick: () => {
        if (openMenu) closeMenu?.();
        navigate(privateRoutes.jobApplication);
      },
    },

    {
      id: 'a8',
      label: 'خروج',
      href: 'logout',
      icon: <LogoutIcon color='error' />,
      onClick: () => logout(),
    },
  ];

  const onRemoveOrgLogo = () => {
    setOpenConfirmDialog(false);
    setRemoveLoading(true);
    removeOrgLog().then(() => {
      getOrgInfo()
        .then((res) => dispatch(setUser(res)))
        .catch((e) => console.log({ e }))
        .finally(() => setRemoveLoading(false));
    });
  };
  const onUploadOrgLogo = (imgFile) => {
    setUploadLoading(true);
    let formData = new FormData();
    formData.append('file', imgFile);
    uploadOrgLogo(formData)
      .then(() => {
        dispatch(
          setSnackbar({
            openSnackbar: true,
            message: 'تصویر پروفایل با موفقیت بارگزاری شد',
          }),
        );
      })
      .catch((e) => console.log({ e }))
      .finally(() => setUploadLoading(false));
  };

  const handelChangeFile = (event) => {
    const imgFile = event.target.files[0];
    let imgSize = imgFile?.size;
    if (imgSize > 5120000) {
      dispatch(
        setSnackbar({
          openSnackbar: true,
          message: 'حجم تصویر انتخابی از ۵ مگابایت نباید بیشتر باشد',
        }),
      );
    } else {
      setFile(imgFile);
      onUploadOrgLogo(imgFile);
    }
  };

  return (
    <Box className='sidebar' sx={{ display: isMobile ? 'flex' : 'auto' }}>
      <Box className='content'>
        <Box className='avatarContainer'>
          <label htmlFor='upload'>
            <Avatar
              sx={{ width: 73, height: 73 }}
              src={file ? URL.createObjectURL(file) : orgLogo}
            />
            <input
              type='file'
              id='upload'
              style={{ display: 'none' }}
              disabled={uploadLoading}
              accept='image/png, image/jpeg, image/jpg'
              onChange={handelChangeFile}
            />
            <Box className='camera' bgcolor={uploadLoading ? 'background.dark' : 'primary.main'}>
              {uploadLoading ? (
                <CircularProgress size={12} color='secondary' />
              ) : (
                <CameraAltOutlinedIcon fontSize='small' />
              )}
            </Box>
          </label>

          {orgLogo && (
            <Box
              className='remove'
              bgcolor={removeLoading ? 'background.dark' : 'secondary.dark'}
              onClick={() => setOpenConfirmDialog(true)}
            >
              {removeLoading ? (
                <CircularProgress size={12} color='secondary' />
              ) : (
                <RemoveRoundedIcon fontSize='small' />
              )}
            </Box>
          )}
        </Box>

        <Box display='flex' gap={1} alignItems='center' mt={1}>
          <Typography>{firstName ? `${firstName} ${lastName}` : '---'}</Typography>
          <Box className='badge' bgcolor='primary.lighter'>
            سازمانی
          </Box>
        </Box>

        <Typography color='secondary.main' fontSize='x-small' fontWeight='bold'>
          {organisationName || '---'}
        </Typography>

        <Typography display='flex' color='text.dark' fontSize='x-small' my={1}>
          موجودی کیف پول:
          <Typography fontWeight='bold' pr={0.5} pl={0.2}>
            {commafy(amount || 0)}
          </Typography>
          تومان
        </Typography>

        <CustomButton variant='outlined' onClick={() => dispatch(setOpenDepositDialog(true))}>
          <Typography>افزایش موجودی</Typography>
        </CustomButton>

        <Divider sx={{ width: '95%', marginTop: '0.5rem' }} />

        <MenuList sx={{ width: '100%' }}>
          {adminSidebarItem.map((item) => {
            return (
              <MenuItem
                selected={item.href === pathname}
                key={item.id}
                onClick={item?.onClick}
                classes={{
                  root: classes.root,
                  selected: classes.selected,
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText sx={{ color: item.href === 'logout' ? '#CC0056' : '' }}>
                  {item.label}
                </ListItemText>
              </MenuItem>
            );
          })}
        </MenuList>
      </Box>

      <Typography color='primary.main'>{`نسخه(v${packageJSON?.version})`}</Typography>

      <ConfirmDialog
        openConfirmDialog={openConfirmDialog}
        closeDialog={() => setOpenConfirmDialog(false)}
        onSubmit={onRemoveOrgLogo}
        title='حذف کردن تصویر پروفایل'
        description={`آیا از حذف کردن تصویر پروفایل مطمئن هستید؟`}
      />
    </Box>
  );
};

export default Sidebar;
